import { Route } from '@angular/router';
import { authGuard, ErrorVariant } from '@ichoosr-core/partner/domain';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: '/customers',
    pathMatch: 'full',
  },
  {
    path: 'auth/login',
    loadComponent: () => import('@ichoosr-core/partner-ui/auth-login').then((f) => f.AuthLoginComponent),
  },
  {
    path: 'auth/verify',
    loadComponent: () => import('@ichoosr-core/partner-ui/auth-verify').then((f) => f.AuthVerifyComponent),
  },
  {
    path: 'forbidden',
    loadComponent: () => import('@ichoosr-core/partner-error-ui').then((f) => f.ForbiddenPageComponent),
  },
  {
    path: 'authentication-error',
    loadComponent: () => import('@ichoosr-core/partner-error-ui').then((f) => f.AuthenticationErrorComponent),
    data: {
      variant: ErrorVariant.PartnerLoginFailed,
    },
  },
  {
    path: 'load-error',
    loadComponent: () => import('@ichoosr-core/partner-error-ui').then((f) => f.PageLoadErrorPageComponent),
  },
  {
    path: 'customers',
    canActivate: [authGuard],
    loadComponent: () =>
      import('@ichoosr-core/partner/deal-overview-feature').then((f) => f.DealOverviewFeatureComponent),
  },
  {
    path: 'customer/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('@ichoosr-core/partner/deal-details-feature').then((f) => f.DealDetailsFeatureComponent),
  },
  {
    path: 'invoices',
    canActivate: [authGuard],
    loadComponent: () =>
      import('@ichoosr-core/partner/partner-portal-invoices').then((f) => f.InvoiceOverviewPageComponent),
  },
  {
    path: '**',
    loadComponent: () => import('@ichoosr-core/partner-error-ui').then((f) => f.NotFoundPageComponent),
  },
];
